import React from 'react';
import { Button } from 'reactstrap';
import { useNavigationActions } from '../../../../context';
import { PauseBillingDetailsFooter } from '../../../shared';

const SupportRequestSubmittedConfirmation = () => {
  // Get navigation actions from context
  const { returnToWLC } = useNavigationActions();

  return (
    <div className="stay-confirmation-content">
      <div className="mb-4">
        <h5 className="mb-4">Your support request has been submitted.</h5>

        <p className="mb-3">
          Thank you for giving us the opportunity to resolve the issues you're facing. Our support team will review your
          request and get back to you as soon as possible.
        </p>

        <p className="mb-3">
          Your billing period is paused for 30 days, and your WHOLE Life Club membership remains fully active while we
          work on addressing your concerns.
        </p>

        <div className="mb-4 text-center">
          <Button color="primary" onClick={returnToWLC} size="lg">
            Continue to WHOLE Life Club
          </Button>
        </div>

        <PauseBillingDetailsFooter className="pause-confirmation-details" />
      </div>
    </div>
  );
};

export default SupportRequestSubmittedConfirmation;
